import { calculateInputResult } from "../calculationInputResult";

export type CopyLibraryItem = {
  type?: "text" | "date" | "number" | null;
  text?: string | null;
  date?: string | null;
  number?: {
    value?: number | null;
    prefix?: string | null;
    suffix?: string | null;
    decimalPlaces?: number | null;
  } | null;
};

export function copyLibraryItemToText(copyLibraryItem: CopyLibraryItem) {
  const prefix = copyLibraryItem?.number?.prefix;
  const suffix = copyLibraryItem?.number?.suffix;
  const value = copyLibraryItem?.number?.value;
  const decimalPlaces = copyLibraryItem?.number?.decimalPlaces;
  const formattedNumericValue =
    value == null
      ? ""
      : typeof decimalPlaces === "number"
      ? value.toFixed(decimalPlaces)
      : value.toString();

  const date = copyLibraryItem?.date
    ? new Date(copyLibraryItem.date + "T00:00:00Z").toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          day: "2-digit",
          year: "2-digit",
          timeZone: "UTC",
        },
      )
    : null;

  switch (copyLibraryItem?.type) {
    case "text":
      return copyLibraryItem.text;
    case "date":
      return date;
    case "number":
      return `${prefix ?? ""}${formattedNumericValue}${suffix ?? ""}`;
    default:
      if (copyLibraryItem?.text) {
        return copyLibraryItem.text;
      }

      return null;
  }
}

export function blocksToText(blocks: any[] = []): string {
  return (
    blocks
      // loop through each block
      .map((block) => {
        // if it's not a text block with children,
        // return nothing
        if (block._type !== "block" || !block.children) {
          return "";
        }
        // loop through the children spans, and join the
        // text strings
        return block.children
          .map((child: any) => {
            if (child._type === "copyLibraryReference") {
              const text = copyLibraryItemToText(child.copyLibraryItem);
              if (text) {
                return text;
              }
              return child.copyLibraryItem?._ref;
            }

            if (child._type === "calculation") {
              const text = calculateInputResult(
                child.calculation,
                child.dynamicNumber?.number?.value,
              );
              if (text) {
                return text;
              }
              return child.dynamicNumber?._ref;
            }

            return child.text;
          })
          .join("");
      })
      .filter(Boolean)
      // join the paragraphs leaving split by two linebreaks
      .join("\n\n")
  );
}
